import Grid, { IGridProps } from '../Grid';
import Skeleton from '../Skeleton';
import { boxShadow2 } from '../../theme';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  truncate: boolean;
  backgroundColor?: string;
  withShadow: boolean;
}

const buildSX = ({ truncate, backgroundColor, withShadow }: IBuildSXParams) => ({
  borderRadius: '16px',
  wordBreak: truncate ? 'break-all' : 'initial',
  backgroundColor: backgroundColor ?? null,
  boxShadow: withShadow ? boxShadow2 : null,
});

export interface IWidgetContainer extends IGridProps {
  isLoading?: boolean;
  truncate?: boolean;
  backgroundColor?: string;
  withShadow?: boolean;
}

const WidgetContainer = (props: IWidgetContainer) => {
  const {
    children, backgroundColor, isLoading, truncate = false, withShadow = false, sx, ...rest
  } = props;

  return (
    <Grid
      px={3}
      py={2}
      sx={mergeSX(buildSX({ truncate, backgroundColor, withShadow }), sx)}
      {...rest}
    >
      {isLoading ? <Skeleton><Grid container>{children}</Grid></Skeleton> : children}
    </Grid>
  );
};

export default WidgetContainer;
